module.exports = __webpack_public_path__ + "img/tr.a6a07c5b.webp";